export function getApiPath() {
    if (process.env.REACT_APP_STAGE === 'dev') {
        return window.location.protocol + "//dev.img-api.com:5112/api"
    }

    return window.location.protocol + "//img-api.com/api"
}